<template>
  <SmartLink
    v-if="!route.active"
    :url="route.url"
    :target="route.target"
    :route="route.route"
    :method="route.method"
    :event="route.event"
    :class="clsx('side-menu-button', { 'side-menu-button--active' : isActivePage })"
    @mouseenter="handleMouseEnter(route.name)"
    @mouseleave="handleMouseLeave(route.name)"
    @touchstart="handleMouseEnter(route.name)"
    @touchend="handleMouseLeave(route.name)"
  >
    <div class="side-menu-icon">
      <component :is="route.icon" :color="route.active || isHovered(route.name) || isActivePage ? '#0A77FF' : '#78829D'" />
    </div>
    {{ route.name }}
  </SmartLink>

  <div v-else class="side-menu-button side-menu-button--active">
    <div class="side-menu-icon">
      <component :is="route.icon" color='#0A77FF' />
    </div>
    {{ route.name }}
  </div>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import { trackHover } from '@/shared/lib/hover';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    route: {
      type: Object,
      default: null,
      required: true,
    },
  },
  mixins: [ trackHover ],
  components: { SmartLink, },
  computed: {
    ...mapGetters('currentPageModule', ['getActivePage']),
    isActivePage() {
      return this.route?.page && this.route?.page === this.getActivePage;
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.side-menu-button {
  position: relative;
  display: block;
  margin: 0 16px;
  padding: 22px 0;
  font-size: 14px;
  font-weight: 500;
  color: #78829D;
  text-align: center;
  text-decoration: none;

  &:hover {
    padding: 21px 0;
    background-color: #ffffff;
    border: 1px solid #0A77FF;
    border-radius: 12px;
    color: #0A77FF;
    box-shadow: 0px 1px 2px 0px #1F37470F, 0px 1px 3px 0px #1F37471A;
  }

  &--active {
    padding: 21px 0;
    background-color: #ffffff;
    border: 1px solid #0A77FF;
    border-radius: 12px;
    color: #0A77FF;
    box-shadow: 0px 1px 2px 0px #1F37470F, 0px 1px 3px 0px #1F37471A;
  }
}

.side-menu-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}
</style>
